<h1 mat-dialog-title>Confirmation</h1>

<div style="padding-bottom: 10px">
  <div *ngFor="let keyValuePair of data.additional_info != null ?  getObjectKeys(data.additional_info) : []">
    <strong>{{ keyValuePair.key }}:</strong> {{ keyValuePair.value }}
  </div>

</div>

<div mat-dialog-content>
  {{ data.message }}
</div>

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" style="color: red">NO</button>
  <button
    mat-button
    [mat-dialog-close]="true"
    style="color: green"
    cdkFocusInitial
  >
    YES
  </button>
</div>

